// @ts-nocheck
import { message } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import {
  selectKitForUpdate,
  setIsKitForUpdate,
  setKitForUpdate,
} from "../../../redux";
import useAppDispatch from "../../../redux/hooks/useAppDispatch";
import { kitsService } from "../../../shared/services";

function normalizeFeatured(value: unknown) {
  return value === true || value === 1 || value === "true" ? "true" : "false";
}

export const useKitsById = () => {
  const [isValidate, setIsValidate] = useState(false);
  const { pathname } = useLocation();
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const kitForUpdate = useSelector(selectKitForUpdate);

  const getSingleKit = async (kitId: number) => {
    return await kitsService
      .get(kitId)
      .then((res) => res)
      .catch((err: any) => {
        console.log(err);
        navigate(`/kits`);
        message.error(err.message);
      });
  };

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      if (id === "new" || pathname === "/kits/new") {
        dispatch(setIsKitForUpdate(false));
        if (!cancelled) setIsValidate(true);
        return;
      }

      const kitId = Number(id);
      if (!Number.isFinite(kitId) || kitId <= 0) {
        navigate(`/kits`);
        return;
      }

      dispatch(setIsKitForUpdate(true));

      // Si ya viene del create (mismo id), no bloquear con spinner.
      if (Number(kitForUpdate?.id) === kitId) {
        if (!cancelled) setIsValidate(true);
        return;
      }

      setIsValidate(false);
      const res = await getSingleKit(kitId);
      if (cancelled || !res) return;

      dispatch(
        setKitForUpdate({
          ...res,
          featured: normalizeFeatured(res.featured),
        })
      );
      setIsValidate(true);
    };

    void load();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, id]);

  return {
    isValidate,
  };
};
